// import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";
// import { StoreProptypes } from "../../PropTypes/StoreProptypes";
// import { Col, Form, Row } from "react-bootstrap";
// import { useEffect, useState } from "react";
// import aioaIconType30 from "../../Assets/img/widget-icon/aioa-hide-icon-type-30.svg";
// import aioaIconType31 from "../../Assets/img/widget-icon/aioa-hide-icon-type-31.svg";
// import aioaIconType32 from "../../Assets/img/widget-icon/aioa-hide-icon-type-32.svg";
// import aioaIconType33 from "../../Assets/img/widget-icon/aioa-hide-icon-type-33.svg";
// import aioaIconType34 from "../../Assets/img/widget-icon/aioa-hide-icon-type-34.svg";

// import useWindowSize from "../../Helpers/useWindowSize";

// // widget icon array
// const widgetIconJson = [
//     {
//         id: 30,
//         iconImage: aioaIconType30,
//     },
//     {
//         id: 31,
//         iconImage: aioaIconType31,
//     },
//     {
//         id: 32,
//         iconImage: aioaIconType32,
//     },
//     {
//         id: 33,
//         iconImage: aioaIconType33,
//     },
//     {
//         id: 34,
//         iconImage: aioaIconType34,
//     },
// ];

// interface PropTypes {
//     setChangeHideWidgetIconType: Function,
//     changeHideWidgetIconType: any
// }

// // component to render widget icon type
// const WidgetHideIconType = (props: PropTypes) => {

//     // PropTypes
//     const { setChangeHideWidgetIconType, changeHideWidgetIconType } = props;

//     // Redux Data
//     const { currentWebsite } = useSelector((store: StoreProptypes) => store);

//     // Functions
//     const { t } = useTranslation();
//     const windowWidth = useWindowSize();

//     // State
//     const [widgetHideIconType, setWidgetHideIconType] = useState<number>(34);

//     // Set current widget icon type
//     useEffect(() => {
//         // check if current website is available
//         if (currentWebsite) {
//             // check if widget icon type is defined
//             if (currentWebsite.widget_hide_icon_type) {
//                 setWidgetHideIconType(currentWebsite.widget_hide_icon_type);
//             } else {
//                 setWidgetHideIconType(34);
//             }
//         }
//     }, [currentWebsite])

//     // set current icon value in prop function
//     useEffect(() => {
//         // check if widget icon type is available
//         if (widgetHideIconType) {
//             setChangeHideWidgetIconType(widgetHideIconType);
//         }
//     }, [widgetHideIconType])
//     console.log("widgetHide", widgetHideIconType, currentWebsite?.widget_hide_icon_type);
//     return (
//         <>
//             <fieldset className="aioa_dashboard-widget-settings-fieldset">
//                 <legend className="visually-hidden">{t("Select Widget Icon Type")}</legend>
//                <div className="icon-grid">
//                     {widgetIconJson.map((iconType, index) => {
//                         return (
//                              <div key={iconType.id}>
//                                 <div className={`aioa_dashboard-widget-setting-icon-box ${iconType.id === 13 ? `flat-logo` : ``} ${(iconType.id === widgetHideIconType) ? 'active' : ''}`}>

//                                     <Form.Check type="radio" id={`icon_type_${iconType.id}`} aria-label={t(`Icon type`, { widgetIconType: iconType.id }).toString()}>

//                                         <Form.Check.Input type="radio" name="widget_icon_type" id="widget_icon_type" checked={iconType.id === widgetHideIconType} className="" onChange={() => setWidgetHideIconType(iconType.id)} />

//                                         <Form.Check.Label>
//                                             <span className="visually-hidden">
//                                                 {t(`Icon type ${iconType.id}`).toString()}
//                                                 {/* {t(`Icon type`, { widgetHideIconType: iconType.id }).toString()} */}
//                                             </span>

//                                             <div className={`aioa_dashboard-widget-icon-box aioaIconType${iconType.id}`}></div>

//                                             <div className="aioa_dashboard-widget-setting-icon-active-icon">
//                                                 <i className="material-symbols-outlined" aria-hidden="true">done</i>
//                                             </div>
//                                         </Form.Check.Label>

//                                     </Form.Check>
//                                 </div>
//                            </div>
//                         )
//                     })}
//                 </div>
//             </fieldset>
//         </>
//     )
// }

// export default WidgetHideIconType;

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import aioaIconType30 from "../../Assets/img/widget-icon/aioa-hide-icon-type-30.svg";
import aioaIconType31 from "../../Assets/img/widget-icon/aioa-hide-icon-type-31.svg";
import aioaIconType32 from "../../Assets/img/widget-icon/aioa-hide-icon-type-32.svg";
import aioaIconType33 from "../../Assets/img/widget-icon/aioa-hide-icon-type-33.svg";
import aioaIconType34 from "../../Assets/img/widget-icon/aioa-hide-icon-type-34.svg";

import useWindowSize from "../../Helpers/useWindowSize";

// widget icon array
const widgetIconJson = [
    {
        id: 30,
        iconImage: aioaIconType30,
    },
    {
        id: 31,
        iconImage: aioaIconType31,
    },
    {
        id: 32,
        iconImage: aioaIconType32,
    },
    {
        id: 33,
        iconImage: aioaIconType33,
    },
    {
        id: 34,
        iconImage: aioaIconType34,
    },
];

interface PropTypes {
    setChangeHideWidgetIconType: Function,
    changeHideWidgetIconType: any
}

// component to render widget icon type
const WidgetHideIconType = (props: PropTypes) => {

    // PropTypes
    const { setChangeHideWidgetIconType, changeHideWidgetIconType } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);

    // Functions
    const { t } = useTranslation();
    const windowWidth = useWindowSize();

    // State
    const [widgetHideIconType, setWidgetHideIconType] = useState<number>(34);

    // Set current widget icon type
    useEffect(() => {
        // check if current website is available
        if (currentWebsite) {
            // check if widget icon type is defined
            if (currentWebsite.widget_hide_icon_type) {
                setWidgetHideIconType(currentWebsite.widget_hide_icon_type);
            } else {
                setWidgetHideIconType(34);
            }
        }
    }, [currentWebsite])

    // set current icon value in prop function
    useEffect(() => {
        // check if widget icon type is available
        if (widgetHideIconType) {
            setChangeHideWidgetIconType(widgetHideIconType);
        }
    }, [widgetHideIconType])
    
    console.log("widgetHide", widgetHideIconType, currentWebsite?.widget_hide_icon_type);
    
    return (
        <>
            <div className="widget-hide-icon-section">
                <div className="widget-hide-icon-header">
                    <label className="widget-hide-icon-label">
                        {t("Hide Widget Icon")}
                    </label>
                    <p className="widget-hide-icon-description">
                        {t("Choose an icon style for the hide widget button")}
                    </p>
                </div>
                
                <fieldset className="aioa_dashboard-widget-settings-fieldset">
                    <legend className="visually-hidden">{t("Select Widget Icon Type")}</legend>
                    <div className="d-flex gap-3 flex-wrap">
                        {widgetIconJson.map((iconType, index) => {
                            return (
                                <div key={iconType.id}>
                                    <div 
                                        className={`aioa_dashboard-widget-setting-icon-box ${iconType.id === 13 ? `flat-logo` : ``} ${(iconType.id === widgetHideIconType) ? 'active' : ''}`}
                                        onClick={() => setWidgetHideIconType(iconType.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <Form.Check type="radio" id={`icon_type_${iconType.id}`} aria-label={t(`Icon type`, { widgetIconType: iconType.id }).toString()}>
                                            <Form.Check.Input 
                                                type="radio" 
                                                name="widget_icon_type" 
                                                id="widget_icon_type" 
                                                checked={iconType.id === widgetHideIconType} 
                                                className="d-none" 
                                                onChange={() => setWidgetHideIconType(iconType.id)} 
                                            />
                                            <Form.Check.Label>
                                                <div className={`aioa_dashboard-widget-icon-box aioaIconType${iconType.id}`}></div>
                                                {/* <div className="text-center mt-2 small">
                                                    {t("Icon")} {iconType.id}
                                                </div> */}
                                                {iconType.id === widgetHideIconType && (
                                                    <div className="aioa_dashboard-widget-setting-icon-active-icon">
                                                        <i className="material-symbols-outlined" aria-hidden="true">check_circle</i>
                                                    </div>
                                                )}
                                            </Form.Check.Label>
                                        </Form.Check>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </fieldset>
            </div>

            <style>{`
                .widget-hide-icon-section {
                    margin-bottom: 20px;
                }
                
                .widget-hide-icon-header {
                    margin-bottom: 16px;
                }
                
                .widget-hide-icon-label {
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                    display: block;
                    margin-bottom: 6px;
                }
                
                .widget-hide-icon-description {
                    font-size: 13px;
                    color: #666;
                    margin: 0;
                    line-height: 1.4;
                }
                
                .aioa_dashboard-widget-settings-fieldset {
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    padding: 20px;
                    margin: 0;
                }
                
                .aioa_dashboard-widget-setting-icon-box {
                    position: relative;
                    text-align: center;
                    padding: 12px;
                    border: 2px solid transparent;
                    border-radius: 8px;
                    transition: all 0.2s ease;
                    background: #fafafa;
                    min-width: 80px;
                }
                
                .aioa_dashboard-widget-setting-icon-box:hover {
                    background: #f0f0f0;
                    transform: scale(1.02);
                }
                
                .aioa_dashboard-widget-setting-icon-box.active {
                    border-color: #007bff;
                    background: #f0f7ff;
                }
                
                .aioa_dashboard-widget-icon-box {
                    width: 48px;
                    height: 48px;
                    margin: 0 auto;
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }
                
                .aioa_dashboard-widget-setting-icon-active-icon {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    background: #007bff;
                    border-radius: 50%;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                
                .aioa_dashboard-widget-setting-icon-active-icon i {
                    color: white;
                    font-size: 16px;
                }
                
                .small {
                    font-size: 12px;
                    color: #666;
                }
            `}</style>
        </>
    )
}

export default WidgetHideIconType;